import { StandardEvents } from '@shopify/events';

class BrazurProductQR extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.details = this.querySelector('details');
    this.details.addEventListener('toggle', () => this.renderCode(), options);
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, (event) => {
      if (!(event.target instanceof Element) || event.target.closest('product-card, dialog')) return;
      event.promise.then(({ detail }) => {
        if (!this.isConnected) return;
        const updated = detail?.html?.querySelector('brazur-product-qr');
        if (!updated) return;
        this.dataset.url = updated.dataset.url;
        this.querySelector('a').href = this.dataset.url;
        this.renderCode();
      }).catch(() => {});
    }, options);
    this.hidden = false;
    this.renderCode();
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  async renderCode() {
    if (!this.details.open) return;
    const url = this.dataset.url;
    if (url === this.renderedUrl) return;
    const container = this.querySelector('.bz-product-qr__code');
    const error = this.querySelector('.bz-product-qr__error');
    container.replaceChildren();
    try {
      const { QRCode } = await import(this.dataset.generator);
      if (!this.isConnected || url !== this.dataset.url) return;
      container.replaceChildren();
      new QRCode(container, { text: url, width: 192, height: 192, colorDark: '#000000', colorLight: '#ffffff', alt: '' });
      this.renderedUrl = url;
      error.hidden = true;
    } catch {
      this.renderedUrl = null;
      error.hidden = false;
    }
  }
}

if (!customElements.get('brazur-product-qr')) {
  customElements.define('brazur-product-qr', BrazurProductQR);
}
